'use strict';Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(value,regexp){return value.replace(regexp,'')};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/cleanValue.js
// module id = 783
// module chunks = 0